import { render, staticRenderFns } from "./PrivacySetting.vue?vue&type=template&id=257dea96&scoped=true"
import script from "./PrivacySetting.vue?vue&type=script&lang=js"
export * from "./PrivacySetting.vue?vue&type=script&lang=js"
import style0 from "./PrivacySetting.vue?vue&type=style&index=0&id=257dea96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257dea96",
  null
  
)

export default component.exports